<h2 mat-dialog-title>Buscar CEP</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Informe o endereço</mat-label>
        <input type="text" matInput
        (ngModelChange)="onChange()"
        [(ngModel)]="address" placeholder="Digite o   Estado, Cidade e Logradouro">                                        
    </mat-form-field>
    <div *ngIf="result.cep"><b>CEP:</b> {{ result.cep | mask: '00000-000' }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">  
  <button mat-button  color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button  color="primary" (click)="searchByRawAddress()">Selecionar</button>
</mat-dialog-actions>




